import { isVeevaMedcomms } from 'const';
import { rootDocument } from 'containers/RootDocument/selectors';
import { DocumentTypeMedcomms, DocumentSubtypeMedcomms } from './constants';

export const isReadOnlySelector = (state): boolean => {
  if (!isVeevaMedcomms()) {
    return false;
  }

  const type = rootDocument(state).get('type') as unknown as DocumentTypeMedcomms;
  const subtype = rootDocument(state).get('subtype') as unknown as DocumentSubtypeMedcomms;

  if (type === DocumentTypeMedcomms.MEDICAL_INITIATED_EMAILS) {
    return true;
  } else if (type === DocumentTypeMedcomms.SCIENTIFIC_CONTENT &&
     ([DocumentSubtypeMedcomms.SCIENTIFIC_SUMMARY, DocumentSubtypeMedcomms.SINGLE_TOPIC_PRESENTATION].includes(subtype))) {
    return true;
  } else {
    return false;
  }
};
